module.exports = __webpack_public_path__ + "img/icc-logo.ae6544e3.jpg";